import React from "react";
import { useTranslation } from "lib/i18n/use-translation";
import { ChatStarter } from "../chat-starters";
import { STARTER_ICONS } from "./oriChatStarterIcons";
import OriStarterPillRow from "./OriStarterPillRow";

interface OriChatStarterPillsProps {
  /** Display order is the caller's choice (shuffled per display). */
  starters: ChatStarter[];
  onSelect: (starter: ChatStarter, index: number) => void;
  disabled?: boolean;
}

/**
 * Conversation-starter pills shown beneath Ori's greeting on a first-time
 * user's fresh chat. Visibility, ordering, and tap side effects live in the
 * page.
 */
const OriChatStarterPills: React.FC<OriChatStarterPillsProps> = ({
  starters,
  onSelect,
  disabled = false,
}) => {
  const { t } = useTranslation(["ori"]);

  return (
    <OriStarterPillRow
      testId="ori-chat-starters"
      items={starters.map((starter) => ({
        key: starter.id,
        label: t(starter.labelKey),
        testId: `ori-chat-starter-${starter.id}`,
        Icon: STARTER_ICONS[starter.id],
      }))}
      onSelect={(index) => onSelect(starters[index], index)}
      disabled={disabled}
    />
  );
};

export default OriChatStarterPills;
